import React, { ReactChild } from 'react'
import './styles.ts'
import Subtitle from '../Subtitle'
import Separator from '../../styles/Separator'
import { DolaThemes } from '../../styles/types'
import { Content } from './styles'
import { P } from '../../styles/Elements'

export interface SubheaderProps {
  leftButton: ReactChild
  rightButton?: ReactChild
  title: ReactChild
  subtitle?: ReactChild
  theme?: DolaThemes
  mobileGridRatio?: string
}

const Subheader: React.FC<SubheaderProps> = ({
  mobileGridRatio,
  leftButton,
  rightButton,
  title,
  subtitle,
  theme = 'light',
}) => {
  return (
    <div className="subheader">
      <Separator dolaTheme={theme} />
      <Content className="subheader__content" mobileGridRatio={mobileGridRatio}>
        <div>{leftButton}</div>
        <div>
          <P>
            <strong>{title}</strong>
          </P>
        </div>
        <div>{rightButton}</div>
      </Content>
      {!subtitle && <Separator dolaTheme={theme} />}
      {subtitle && <Subtitle theme={theme} subtitle={subtitle} />}
    </div>
  )
}

export default Subheader
